/**
 * Platzhalter fuer einen noch nicht migrierten Screen.
 * Der Inhalt kommt 1:1 aus dem eingefrorenen Prototyp (Frontend V1) und wird
 * Screen fuer Screen uebernommen – hier wird nichts neu erfunden.
 */
export function Placeholder({ title, note }: { title: string; note?: string }) {
  return (
    <section>
      <h1 className="ph-screen__title">{title}</h1>
      <p className="ph-screen__note">
        {note ?? 'Wird aus dem eingefrorenen Prototyp (Frontend V1) migriert.'}
      </p>
    </section>
  );
}
